'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _metrixCommon = require('metrix-common');

var _Address = require('../Components/Address');

var _Address2 = _interopRequireDefault(_Address);

var _Back = require('../Components/Back');

var _Back2 = _interopRequireDefault(_Back);

var _Header = require('../Components/Header');

var _Header2 = _interopRequireDefault(_Header);

var _Name = require('../Components/Name');

var _Name2 = _interopRequireDefault(_Name);

var _Date = require('../Components/Date');

var _Date2 = _interopRequireDefault(_Date);

var _DateRange = require('../Components/DateRange');

var _DateRange2 = _interopRequireDefault(_DateRange);

var _Dropdown = require('../Components/Dropdown');

var _Dropdown2 = _interopRequireDefault(_Dropdown);

var _Classification = require('../Components/Classification');

var _Classification2 = _interopRequireDefault(_Classification);

var _Input = require('../Components/Input');

var _Input2 = _interopRequireDefault(_Input);

var _Selection = require('../Components/Selection');

var _Selection2 = _interopRequireDefault(_Selection);

var _IconRadio = require('../Components/IconRadio');

var _IconRadio2 = _interopRequireDefault(_IconRadio);

var _IconChecklist = require('../Components/IconChecklist');

var _IconChecklist2 = _interopRequireDefault(_IconChecklist);

var _Label = require('../Components/Label');

var _Label2 = _interopRequireDefault(_Label);

var _Checklist = require('../Components/Checklist');

var _Checklist2 = _interopRequireDefault(_Checklist);

var _Phone = require('../Components/Phone');

var _Phone2 = _interopRequireDefault(_Phone);

var _ToolTip = require('../Components/ToolTip');

var _ToolTip2 = _interopRequireDefault(_ToolTip);

var _Image = require('../Components/Image');

var _Image2 = _interopRequireDefault(_Image);

var _Switch = require('../Components/Switch');

var _Switch2 = _interopRequireDefault(_Switch);

var _Summary = require('../Components/Summary');

var _Summary2 = _interopRequireDefault(_Summary);

var _ListGroup = require('../Components/ListGroup');

var _ListGroup2 = _interopRequireDefault(_ListGroup);

var _Link = require('../Components/Link');

var _Link2 = _interopRequireDefault(_Link);

var _LinkButton = require('../Components/LinkButton');

var _LinkButton2 = _interopRequireDefault(_LinkButton);

var _Slider = require('../Components/Slider');

var _Slider2 = _interopRequireDefault(_Slider);

var _Checkbox = require('../Components/Checkbox');

var _Checkbox2 = _interopRequireDefault(_Checkbox);

var _Radio = require('../Components/Radio');

var _Radio2 = _interopRequireDefault(_Radio);

var _DocumentUpload = require('../Components/DocumentUpload');

var _DocumentUpload2 = _interopRequireDefault(_DocumentUpload);

var _Grid = require('../Components/Grid');

var _Grid2 = _interopRequireDefault(_Grid);

var _ImageSelection = require('../Components/ImageSelection');

var _ImageSelection2 = _interopRequireDefault(_ImageSelection);

var _AddressAutocomplete = require('../Components/AddressAutocomplete');

var _AddressAutocomplete2 = _interopRequireDefault(_AddressAutocomplete);

var _Streetview = require('../Components/Streetview');

var _Streetview2 = _interopRequireDefault(_Streetview);

var _StreetviewStatic = require('../Components/StreetviewStatic');

var _StreetviewStatic2 = _interopRequireDefault(_StreetviewStatic);

var _MapviewDynamic = require('../Components/MapviewDynamic');

var _MapviewDynamic2 = _interopRequireDefault(_MapviewDynamic);

var _Contact = require('../Components/Contact');

var _Contact2 = _interopRequireDefault(_Contact);

var _ContactRequest = require('../Components/ContactRequest');

var _ContactRequest2 = _interopRequireDefault(_ContactRequest);

var _ContactDetails = require('../Components/ContactDetails');

var _ContactDetails2 = _interopRequireDefault(_ContactDetails);

var _AutoRedirect = require('../Components/AutoRedirect');

var _AutoRedirect2 = _interopRequireDefault(_AutoRedirect);

var _UsageGroup = require('../Components/UsageGroup');

var _UsageGroup2 = _interopRequireDefault(_UsageGroup);

var _FileUploader = require('../Components/FileUploader');

var _FileUploader2 = _interopRequireDefault(_FileUploader);

var _PlaceAutocomplete = require('../Components/PlaceAutocomplete');

var _PlaceAutocomplete2 = _interopRequireDefault(_PlaceAutocomplete);

var _Table = require('../Components/Table');

var _Table2 = _interopRequireDefault(_Table);

var _TableGroup = require('../Components/TableGroup');

var _TableGroup2 = _interopRequireDefault(_TableGroup);

var _ValidationBanner = require('../Components/ValidationBanner');

var _ValidationBanner2 = _interopRequireDefault(_ValidationBanner);

var _CustomPlaceAutocomplete = require('../Components/CustomPlaceAutocomplete');

var _CustomPlaceAutocomplete2 = _interopRequireDefault(_CustomPlaceAutocomplete);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Component = function (_React$Component) {
    _inherits(Component, _React$Component);

    function Component() {
        _classCallCheck(this, Component);

        return _possibleConstructorReturn(this, (Component.__proto__ || Object.getPrototypeOf(Component)).apply(this, arguments));
    }

    _createClass(Component, [{
        key: 'render',
        value: function render() {
            var visible = (0, _metrixCommon.getElementValueByCode)(this.props.component.elements, 'visible');
            if (visible === false) return null;

            var baseProps = {
                context: this.props.context,
                reference: this.props.reference,
                component: this.props.component,
                return: this.props.return,
                doSetReturn: this.props.doSetReturn,
                doReduceDynamicDate: this.props.doReduceDynamicDate,
                mobile: (0, _metrixCommon.isMobile)(this.context.screenSize),
                tablet: (0, _metrixCommon.isTablet)(this.context.screenSize),
                desktop: (0, _metrixCommon.isDesktop)(this.context.screenSize),
                entity: this.props.entity,
                recursive: this.props.recursive,
                dotProp: this.props.dotProp,
                workflowConfiguration: this.props.workflowConfiguration
            };

            var component = void 0;
            var wide = false;

            switch (this.props.component.type) {
                case 'customPlaceAutocomplete':
                    component = _react2.default.createElement(_CustomPlaceAutocomplete2.default, baseProps);
                    break;
                case 'locationAutocomplete':
                    component = _react2.default.createElement(_AddressAutocomplete2.default, baseProps);
                    break;
                case 'streetview':
                    component = _react2.default.createElement(_Streetview2.default, baseProps);
                    break;
                case 'streetviewStatic':
                    component = _react2.default.createElement(_StreetviewStatic2.default, baseProps);
                    break;
                case 'mapviewDynamic':
                    component = _react2.default.createElement(_MapviewDynamic2.default, baseProps);
                    break;
                case 'location':
                    component = _react2.default.createElement(_Address2.default, _extends({}, baseProps, { reference: this.props.reference }));
                    break;
                case 'navigation':
                case 'backButton':
                    component = _react2.default.createElement(_Back2.default, _extends({}, baseProps, { doStep: this.props.doStep }));
                    wide = true;
                    break;
                case 'back':
                    component = _react2.default.createElement(_Back2.default, _extends({}, baseProps, { doStep: this.props.doStep }));
                    break;
                case 'header':
                    component = _react2.default.createElement(_Header2.default, baseProps);
                    break;
                case 'label':
                    component = _react2.default.createElement(_Label2.default, baseProps);
                    break;
                case 'name':
                    component = _react2.default.createElement(_Name2.default, baseProps);
                    break;
                case 'date':
                    component = _react2.default.createElement(_Date2.default, _extends({}, baseProps, { culture: this.props.culture }));
                    break;
                case 'dateRange':
                    component = _react2.default.createElement(_DateRange2.default, _extends({}, baseProps, { culture: this.props.culture }));
                    break;
                case 'dropDown':
                    component = _react2.default.createElement(_Dropdown2.default, baseProps);
                    break;
                case 'classification':
                    component = _react2.default.createElement(_Classification2.default, baseProps);
                    break;
                case 'valueFrequency':
                case 'input':
                    component = _react2.default.createElement(_Input2.default, baseProps);
                    break;
                case 'imageSelection':
                    component = _react2.default.createElement(_ImageSelection2.default, _extends({}, baseProps, { doStep: this.props.doStep, valid: this.props.valid }));
                    break;
                case 'next':
                    component = _react2.default.createElement(_Selection2.default, _extends({}, baseProps, { doStep: this.props.doStep, valid: this.props.valid, emphasizeFirst: true, trackAnalytics: this.props.trackAnalytics }));
                    break;
                case 'selection':
                    component = _react2.default.createElement(_Selection2.default, _extends({}, baseProps, { doStep: this.props.doStep, valid: this.props.valid, trackAnalytics: this.props.trackAnalytics }));
                    break;
                case 'iconRadio':
                    component = _react2.default.createElement(_IconRadio2.default, _extends({}, baseProps, { doStep: this.props.doStep, valid: this.props.valid }));
                    break;
                case 'iconChecklist':
                    component = _react2.default.createElement(_IconChecklist2.default, _extends({}, baseProps, { doStep: this.props.doStep, valid: this.props.valid }));
                    break;
                case 'checklist':
                    component = _react2.default.createElement(_Checklist2.default, baseProps);
                    break;
                case 'phone':
                    component = _react2.default.createElement(_Phone2.default, baseProps);
                    break;
                case 'image':
                    component = _react2.default.createElement(_Image2.default, baseProps);
                    break;
                case 'switch':
                    component = _react2.default.createElement(_Switch2.default, baseProps);
                    break;
                case 'summary':
                    component = _react2.default.createElement(_Summary2.default, _extends({}, baseProps, { doStep: this.props.doStep }));
                    break;
                case 'listGroup':
                    component = _react2.default.createElement(_ListGroup2.default, baseProps);
                    break;
                case 'link':
                    component = _react2.default.createElement(_Link2.default, _extends({}, baseProps, { configuration: this.props.configuration }));
                    break;
                case 'linkButton':
                    component = _react2.default.createElement(_LinkButton2.default, { component: this.props.component,
                        doExecuteAction: this.props.doExecuteAction,
                        doSetReturn: this.props.doSetReturn,
                        valid: this.props.valid,
                        trackAnalytics: this.props.trackAnalytics
                    });
                    break;
                case 'slider':
                    component = _react2.default.createElement(_Slider2.default, baseProps);
                    break;
                case 'checkbox':
                    component = _react2.default.createElement(_Checkbox2.default, baseProps);
                    break;
                case 'radio':
                    component = _react2.default.createElement(_Radio2.default, baseProps);
                    break;
                case 'documentUpload':
                    component = _react2.default.createElement(
                        _metrixCommon.DocumentProvider,
                        null,
                        _react2.default.createElement(_DocumentUpload2.default, _extends({}, baseProps, { session: this.props.session }))
                    );
                    break;
                case 'grid':
                    component = _react2.default.createElement(_Grid2.default, baseProps);
                    break;
                case 'contact':
                    component = _react2.default.createElement(_Contact2.default, _extends({}, baseProps, { session: this.props.session }));
                    break;
                case 'contactRequest':
                    component = _react2.default.createElement(_ContactRequest2.default, baseProps);
                    break;
                case 'contactDetails':
                    component = _react2.default.createElement(_ContactDetails2.default, baseProps);
                    break;
                case 'autoRedirect':
                    component = _react2.default.createElement(_AutoRedirect2.default, baseProps);
                    break;
                case 'usageGroup':
                    component = _react2.default.createElement(_UsageGroup2.default, baseProps);
                    break;
                case 'fileUploader':
                    component = _react2.default.createElement(_FileUploader2.default, baseProps);
                    break;
                case 'placeAutocomplete':
                    component = _react2.default.createElement(_PlaceAutocomplete2.default, baseProps);
                    break;
                case 'table':
                    component = _react2.default.createElement(_Table2.default, _extends({}, baseProps, { doStep: this.props.doStep }));
                    break;
                case 'tableGroup':
                    component = _react2.default.createElement(_TableGroup2.default, _extends({}, baseProps, { doStep: this.props.doStep, returns: this.props.returns }));
                    break;
                case 'validationBanner':
                    component = _react2.default.createElement(_ValidationBanner2.default, baseProps);
                    break;
                default:
                    component = _react2.default.createElement(
                        'div',
                        null,
                        '****',
                        this.props.component.type,
                        '****'
                    );
                    break;
            }

            var workflowComponent = void 0;

            if (this.props.component.type === 'contact' || this.props.component.type === 'contactRequest' || this.props.component.type === 'contactDetails') {
                workflowComponent = _react2.default.createElement(
                    _metrixCommon.Container,
                    null,
                    component
                );
            } else if (this.props.component.recursive || this.props.component.type === 'table') {
                workflowComponent = component;
            } else {
                workflowComponent = _react2.default.createElement(
                    _metrixCommon.Grid,
                    null,
                    _react2.default.createElement(
                        _metrixCommon.Row,
                        { nogutter: this.props.component.type === 'slider' || this.props.component.type === 'back', noguttertop: baseProps.mobile },
                        !this.props.inline && _react2.default.createElement(_metrixCommon.Column, { xs: 1, md: wide ? 1 : 2 }),
                        _react2.default.createElement(
                            _metrixCommon.Column,
                            { xs: this.props.inline ? 12 : 10, md: this.props.inline ? 12 : wide ? 10 : 8 },
                            component
                        ),
                        baseProps.mobile && _react2.default.createElement(
                            _react2.default.Fragment,
                            null,
                            _react2.default.createElement(_metrixCommon.Column, { xs: 1 }),
                            _react2.default.createElement(_metrixCommon.Column, { xs: 1 })
                        ),
                        !this.props.inline && _react2.default.createElement(
                            _metrixCommon.Column,
                            { xs: 1, md: wide ? 1 : 2 },
                            (0, _metrixCommon.getElementsByType)(this.props.component.elements, 'toolTip') && _react2.default.createElement(_ToolTip2.default, baseProps)
                        )
                    )
                );
            }

            return workflowComponent;
        }
    }]);

    return Component;
}(_react2.default.Component);

Component.contextTypes = {
    screenSize: _propTypes2.default.string
};

exports.default = Component;